
export default {
  name: 'SkillRadar',
  functional: true,
  render(h, context) {
    const showLevelName = function(items, isSubSkill = false) {
      if (isSubSkill) {
        return getSkillName4show(items, ...getProps(items));
      } else {
        return items.map((item) => {
          return {
            ...item,
            value: getSkillName4show(item.data, ...getProps(item))
          };
        });
      }
    };
    const getSkillName4show = function(items, levelNameProp, valueProp) {
      const value = items[valueProp] === undefined ? items.fieldsLevel : (items[valueProp] || 0);
      const levelName = items[levelNameProp] ? (items[levelNameProp].length > 5 ? items[levelNameProp].slice(0, 5) + '...' : items[levelNameProp]) : '';
      if (context.props.virtualLine) {
        return '';
      }
      if (context.props.noEvalPlaned) {
        return items[levelNameProp] || value;
      }
      return levelName ? `${levelName}（${value}）` : value;
    };
    const getProps = function(items) {
      const matchedLegend = context.props.fields.find((item) => item.name === items.fieldsType);
      return matchedLegend ? [matchedLegend.props.hoverLevelProp, matchedLegend.props.hoverValueProp] : [];
    };
    return <yxtbiz-polestar-radar
      {...{
        ...context.data,
        props: {
          connectNulls: true,
          ...context.props,
          valueMap: showLevelName
        }
      }}
    />;
  }
};
